/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
import React from 'react';
import {
  ContactCardItem,
  ContactCardPicture,
  ContactCardLabel,
  ContactCardDescription,
  ContactCardButton,
  ContactCardIcon,
  ContactCardLink,
  ContactCardPhone,
  FooterText
} from './style';

const ContactCardItemComponent = ({ title, subtitle, button, order, footerText, error}) => {

  const unavailableButtonStyle = {
    cursor: 'auto',
    padding: '8px',
    opacity: '0.6'
  }

  return (
    <>
      <ContactCardItem>
        <ContactCardPicture aria-hidden="true">
          {order === '1' ? (
            <ContactCardIcon
              icon="💬"
              size="3rem"
            />
          ) : (
            <ContactCardIcon
              icon="💁"
              size="3rem"
            />
          )}
        </ContactCardPicture>
        
        <div className="text-center">
          <ContactCardLabel>{title}</ContactCardLabel>
          <ContactCardDescription>{subtitle}</ContactCardDescription>
          <ContactCardPhone className="d-flex justify-content-center">
            <ContactCardIcon aria-hidden="true" icon="🕾" marginRight=".4rem" />
            <ContactCardLink
              href={`tel:${button.url}`}
              target={button.newWindow ? '_blank' : '_self'}
              className="skip-nav-focus"
            >
              <u>{button.title}</u>
            </ContactCardLink>
          </ContactCardPhone>
          <FooterText className="mt-4 mb-0 text-center font-italic">{footerText}</FooterText>
        </div>
      </ContactCardItem>
    </>
  )
};

export default ContactCardItemComponent;